import * as React from "react";
// components
import Icon from "../../../icons";
import ImageHolder from "common/components/imageHolder";
// styles

const styles = require("./mediaThumbnail.scss");

const ImageThumbnail = ({
  url,
  wrapperStyle,
}: {
  url: string;
  wrapperStyle?: React.CSSProperties;
}) => {
  return (
    <div className={styles.imageContainer} style={wrapperStyle}>
      <ImageHolder fit="cover" src={url} width="100%" height="100%" />
    </div>
  );
};

const LinkPreviewThumbnail = ({
  url,
  wrapperStyle,
  hideIcon,
}: {
  url: string;
  wrapperStyle?: React.CSSProperties;
  hideIcon: boolean;
}) => {
  return (
    <div className={styles.linkPreviewContainer} style={wrapperStyle}>
      <ImageHolder fit="cover" src={url} />
      {hideIcon ? null : (
        <Icon icon="COMPACT_CARD_LINKPREVIEW_BADGE" className={styles.badge} />
      )}
    </div>
  );
};

const PlayableThumbnail = ({
  type,
  url,
  wrapperStyle,
  hideIcon,
}: {
  type: string;
  url: string;
  wrapperStyle?: React.CSSProperties;
  hideIcon: boolean;
}) => {
  return (
    <div className={styles.videoContainer} style={wrapperStyle}>
      <ImageHolder fit="cover" src={`${url}`} />
      {type === "image/gif" ? (
        hideIcon ? null : (
          <Icon icon="COMPACT_CARD_GIF_BADGE" className={styles.badge} />
        )
      ) : hideIcon ? null : (
        <Icon icon="COMPACT_CARD_PLAY_BUTTON" className={styles.playButton} />
      )}
    </div>
  );
};

interface IProps {
  type: Vingle.MediaType;
  url: string | null;
  wrapperStyle?: React.CSSProperties;
  hideIcon?: boolean;
}

const MediaThumbnail = ({
  type,
  url,
  wrapperStyle,
  hideIcon = false,
}: IProps) => {
  if (!url) {
    return null;
  }
  switch (type) {
    case "image":
      return <ImageThumbnail url={url} wrapperStyle={wrapperStyle} />;
    case "link-preview":
      return (
        <LinkPreviewThumbnail
          url={url}
          wrapperStyle={wrapperStyle}
          hideIcon={hideIcon}
        />
      );
    case "video":
    case "video/mp4":
    case "image/gif":
    case "embedded-video":
      return (
        <PlayableThumbnail
          type={type}
          url={url}
          wrapperStyle={wrapperStyle}
          hideIcon={hideIcon}
        />
      );
    default:
      return null;
  }
};

export default MediaThumbnail;
